import { ILicenseCustomer, LicenseCustomer } from "./LicenseCustomer";

export class LicenseOrder extends LicenseCustomer implements ILicenseOrder {
    constructor(licenseOrder: ILicenseOrder) {
        super(licenseOrder);
        if (licenseOrder) {
            this.transactionId = licenseOrder.transactionId;
            this.productId = licenseOrder.productId;
            this.orderNumber = licenseOrder.orderNumber;
            this.priceCode = licenseOrder.priceCode;
            this.forceCancelation = licenseOrder.forceCancelation;
        }
    }

    transactionId: string;
    productId: string;
    orderNumber: string;
    priceCode: string;
    forceCancelation: boolean;
}

export interface ILicenseOrder extends ILicenseCustomer {
    transactionId: string;
    productId: string;
    orderNumber: string;
    priceCode: string;
    forceCancelation: boolean;
}